import { useMediaQuery } from 'react-responsive';
import styles from './healthcare-case1.module.css';

import { Container } from '../../components';
import { useMounted } from '../../hooks';
import arm from '../../public/healthcare/case1/arm.webp';
import PuzzleMobile from '../../public/healthcare/case1/puzzle-mobile.svg';
import Puzzle from '../../public/healthcare/case1/puzzle.svg';
import ConnectMobile from '../../public/svg/connect-mobile.svg';
import Connect from '../../public/svg/connect.svg';
import MultpleLineBottom from '../../public/svg/multple-line-bottom.svg';
import HealthcareDescription from './healthcare-description';
import HealthcareProjectCard, {
  HealthcareProject,
} from './healthcare-project-card';
import HealthcareProjectList from './healthcare-project-list';
import InstaIcon from './icons/instagram.svg';
import LineLeft from './icons/line-left.svg';
import LineRight from './icons/line-right.svg';

const projects: HealthcareProject[] = [
  {
    alt: 'hera image',
    src: '/healthcare/case1/screen1.webp',
    title: 'Pregnancy',
  },
  {
    alt: 'hera image',
    src: '/healthcare/case1/screen2.webp',
    title: 'Survey',
  },
  {
    alt: 'hera image',
    src: '/healthcare/case1/screen3.webp',
    title: 'Yoga',
  },
  {
    alt: 'hera image',
    src: '/healthcare/case1/screen4.webp',
    title: 'Baby Development',
  },
];

export default function HealthcareCase1() {
  const mounted = useMounted();
  const isTablet = useMediaQuery({ maxDeviceWidth: 1023 });

  return (
    <div className={styles.case1}>
      <Container>
        <div className={styles.case1_inner}>
          <HealthcareDescription
            title="Case #1"
            text="This is an ultimate motherhood guide app that helps pregnant women, moms of the newborns and women who faced the pregnancy loss."
          />
          {mounted && !isTablet ? (
            <Connect className={styles.case1_connect} />
          ) : (
            <ConnectMobile className={styles.case1_connectMobile} />
          )}
          <h4 className={styles.case1_title}>The Hera App</h4>
          {mounted && !isTablet ? (
            <img
              alt="multiline"
              src="/svg/multple-line.svg"
              className={styles.multpleLine}
            />
          ) : (
            <ConnectMobile className={styles.case1_connect} />
          )}

          <HealthcareProjectList projects={projects} />
          <MultpleLineBottom className={styles.multpleLine} />
          {mounted && isTablet && (
            <ConnectMobile className={styles.case1_connectMobile} />
          )}
          <div className={styles.case1_wrapper}>
            <div className={styles.case1_wrapperStart}>
              <HealthcareProjectCard
                alt="hera image"
                src="/healthcare/case1/screen5.webp"
              />
            </div>
            <div className={styles.case1_wrapperMiddle}>
              {mounted && !isTablet ? (
                <Puzzle className={styles.case1_puzzle} />
              ) : (
                <PuzzleMobile className={styles.case1_puzzleMobile} />
              )}
              {mounted && !isTablet && (
                <img
                  className={styles.case1_arm}
                  src={arm.src}
                  alt="decor arm"
                />
              )}
            </div>
            <div className={styles.case1_wrapperEnd}>
              <HealthcareProjectCard
                alt="hera image"
                src="/healthcare/case1/screen6.webp"
              />
            </div>
          </div>
          <div className={styles.case1_box}>
            {mounted && isTablet ? (
              <ConnectMobile className={styles.case1_connectMobile} />
            ) : (
              <LineLeft className={styles.case1_lineLeft} />
            )}

            {mounted && isTablet ? null : (
              <LineRight className={styles.case1_lineRight} />
            )}

            <div className={styles.case1_btns}>
              <a
                className={styles.case1_btn}
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.instagram.com/theheraapp/"
              >
                <InstaIcon />
              </a>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
